import {useState, useEffect} from "react";
import dynamic from "next/dynamic";

const CountUp = dynamic(() => import("react-countup"), {ssr: false});
import DetailsComponent from "@/components/ui/cards/DetailsComponent";
import styles from "@/components/ev-details/RangeDetails.module.css";

const RangeDetails = ({data}) => {
  const instructionText = "Range estimates gathered from primary and secondary sources, adjusted to ‘normal’ driving style during different seasons. Actual figures may vary."
  const sortedData = data.sort((a, b) => a.cw_position - b.cw_position);
  const defaultIndex = sortedData.findIndex(
    (detail) => detail.label === "Average"
  );

  // Set the initial state based on the 'Average' detail.
  const [currentRange, setCurrentRange] = useState(
    sortedData[defaultIndex]?.value || 0
  );
  const [prevRange, setPrevRange] = useState(0);
  const [currentUnit, setCurrentUnit] = useState(
    sortedData[defaultIndex]?.unit || ""
  );
  const [selectedDetailIndex, setSelectedDetailIndex] = useState(defaultIndex);

  const handleClick = (detail, index) => {
    setPrevRange(currentRange);
    setCurrentRange(detail.value);
    setCurrentUnit(detail.unit || "");
    setSelectedDetailIndex(index);
  };

  return (
    <DetailsComponent title="Brand new range" toolTipText={instructionText} showToggle={false}>
      <div className={styles.rangeBox}>
        <div className={styles.rangeNumber}>
          <CountUp start={prevRange} end={currentRange} duration={0.5}/>
        </div>
        <div className={styles.rangeUnit}>{currentUnit}</div>
      </div>
      <div className={styles.rangeContent}>
        {sortedData.map((detail, index) => (
          <div
            key={index}
            onClick={() => handleClick(detail, index)}
            className={`${styles.rangeOption} ${
              index === selectedDetailIndex ? styles.selected : ""
            }`}>
            <div className={styles.rangeIcon}>{detail.icon}</div>
            <div className={styles.rangeLabel}>{detail.label}</div>
            {/* <div>
              {detail.value}
              {detail.unit ? ` ${detail.unit}` : ""}
            </div> */}
          </div>
        ))}
      </div>
    </DetailsComponent>
  );
};

export default RangeDetails;
